// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__7uk5F","title":"styles_title__8KtE0"};